module.exports = __webpack_public_path__ + "img/2025-07-21c_3.aa23314b.jpg";